import type { ISEOProps } from "../types/core";

export const DMCA_takedownPolicyPageSEO: ISEOProps = {
  title: "DMCA Takedown Policy - Sugar Cribs",
  description:
    "Learn about Sugar Cribs DMCA takedown policy and how to report copyright infringement on our platform.",
};
